// client/src/pages/RegisterSelectPage.js
// 가입 선택 — v5 신설 (B안 확정: 그라디언트 니즈 카드 2종)
// 역할을 고르면 각 가입 페이지로 이동한다.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import '../styles/public/pub.css';

function RegisterSelectPage() {
  const nav = useNavigate();

  return (
    <div className="pub">
      <Header />
      <main className="wrap">
        <div className="pub-head">
          <h1>셀프애드 시작하기</h1>
          <p>어떤 역할로 시작하시겠어요? 가입은 3분이면 충분해요.</p>
        </div>

        <div className="join">
          <button type="button" className="join-b join-b--mkt" onClick={() => nav('/marketer/register')}>
            <span className="who">광고주</span>
            <span className="need">“제품을 알리고 싶어요”</span>
            <span className="how">나노·마이크로 인플루언서를 직접 모집하고<br />검수부터 성과 확인까지 한곳에서</span>
            <span className="cta">광고주로 시작하기 →</span>
          </button>
          <button type="button" className="join-b join-b--inf" onClick={() => nav('/influencer/register')}>
            <span className="who">인플루언서</span>
            <span className="need">“내 SNS로 보상받고 싶어요”</span>
            <span className="how">참여할 프로젝트를 고르고, 승인되면<br />포인트로 적립 · 통장으로 환전</span>
            <span className="cta">인플루언서로 시작하기 →</span>
          </button>
        </div>

        <p className="t-sub" style={{ textAlign: 'center', marginTop: 16 }}>
          가입 절차는 각 가입 페이지에서 단계별로 안내돼요.
        </p>
        <p className="t-sub" style={{ textAlign: 'center', marginTop: 8 }}>
          이미 계정이 있으신가요?{' '}
          <button
            type="button"
            onClick={() => nav('/')}
            style={{ color: '#1f4fd6', fontWeight: 700, background: 'none', border: 0, cursor: 'pointer', fontFamily: 'inherit', fontSize: 'inherit', padding: 0 }}
          >
            로그인
          </button>
        </p>
      </main>
    </div>
  );
}

export default RegisterSelectPage;
